import React from "react";
import PropTypes from "prop-types";
import styled, { withTheme } from "styled-components";
import DateSelector from "components/DateSelector";
import CheckboxField from "fields/Checkbox";
import DatePicker from "fields/DatePickerFilter";
import { Field } from "react-final-form";
import { parseDateToMsecs } from "lib/date-helpers";
import { useRouter } from "next/router";
import { DateTime } from "luxon";

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopBar = styled.div`
  width: 100%;
  border-bottom: 0.0625rem solid ${({ theme }) => theme.themeColors.lightGrey};
  height: 8.225rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5625rem;
  p{
    margin:0;
    &.small {
      font-size: ${({ theme }) => theme.fontSize(1)};
      color: ${({ theme }) => theme.themeColors.darkGreen4};
    }
  }
  ${({ theme }) => theme.mq.lg`
    flex-direction: row;
    height: 4.125rem;
    padding: 1rem 1.875rem;
  `}
`;

const TopBarWrapper = styled.div`
  height: 4.125rem;
  display: flex;
  align-items: center;
  padding: 1rem 1.5625rem 1rem 0;
`;

const StyledCheckbox = styled(CheckboxField)`
  margin: 0;
`;

const ProviderCount = styled.h3`
  font-size: ${({ theme }) => theme.fontSize(4)};
  letter-spacing: -0.025rem;
  line-height: 1.75rem;
  margin: 0.3125rem 0 1.5rem 0;
  ${({ theme }) => theme.mq.lg`
    margin: 0.3125rem 0 0 0;
    align-self: center;
  `}
`;

const ResultsHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  ${({ theme }) => theme.mq.lg`
    flex-direction: row;
    padding: 0.75rem 1.9rem;
  `}
`;

const DatePickerContainer = styled.div`
  margin-right: 1.875rem;
`;

const StyledDatePicker = styled(DatePicker)`
  display: flex;
  align-items: center;
`;

function BusinessResultsHeader({
  dateArr,
  recordCount,
  updateDayColumns,
  updateSelectedDay,
  a,
  handleAvailabilitySort,
}) {
  const { query } = useRouter();
  const currentTime = DateTime.now();
  // use the URL param startDateTime if it exists otherwise use the current time .i.e now
  const startTime =
    (query.startDateTime &&
      DateTime.fromMillis(parseInt(query.startDateTime, 10)).toJSDate()) ||
    currentTime.ts;
  const tomorrow = currentTime.plus({ days: 1 }).toJSDate();
  return (
    <OuterWrapper>
      <TopBar>
        <TopBarWrapper>
          <DatePickerContainer>
            <Field
              component={StyledDatePicker}
              name="startDateTime"
              parse={parseDateToMsecs}
              minDate={tomorrow}
              input={{
                onChange: (e) => {
                  updateSelectedDay(e.toISOString());
                },
                value: startTime,
              }}
            />
          </DatePickerContainer>
          <StyledCheckbox
            label="Accepts online bookings"
            input={{
              checked: a === "true",
              onChange: (e) => {
                handleAvailabilitySort(e.target.checked);
              },
            }}
          />
        </TopBarWrapper>
        <p className="small">All times are relative to your time zone</p>
      </TopBar>
      <ResultsHeaderContainer>
        <ProviderCount>{recordCount} Providers</ProviderCount>
        <DateSelector
          dateArr={dateArr}
          updateDayColumns={updateDayColumns}
          updateSelectedDay={updateSelectedDay}
        />
      </ResultsHeaderContainer>
    </OuterWrapper>
  );
}

export default withTheme(BusinessResultsHeader);

BusinessResultsHeader.propTypes = {
  dateArr: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({}),
    ])
  ),
  recordCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.shape({
    themeColors: PropTypes.shape({
      secondary: PropTypes.string,
    }),
  }),
  updateDayColumns: PropTypes.func,
  updateSelectedDay: PropTypes.func,
  handleAvailabilitySort: PropTypes.func,
  a: PropTypes.string,
};

BusinessResultsHeader.defaultProps = {
  dateArr: [],
  recordCount: undefined,
  theme: {
    secondary: undefined,
  },
  updateDayColumns: () => {},
  updateSelectedDay: () => {},
  handleAvailabilitySort: () => {},
  a: undefined,
};
